import { render } from "./App.vue?vue&type=template&id=d1d1b8e4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d1d1b8e4&lang=scss"

import exportComponent from "C:\\Users\\86131\\Desktop\\睿捷项目\\face-pro-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__